import { FormattedMessage } from 'react-intl';
import { Cell, Row } from '@tlx/atlas';

export function TableError() {
    return (
        <Row>
            {/* TODO: maybe add atl-tr if containers border gets removed due to tr having border and the container itself having a border making it a double bottom border*/}
            <Cell
                column={'1/-1'}
                className={'atl-flex atl-flex-col atl-items-center atl-justify-center tsk-table__error'}
            >
                <svg
                    className="atl-mb-24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="50px"
                    viewBox="0 0 24 19"
                    width="48px"
                    fill="#e83645"
                >
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
                </svg>
                <FormattedMessage id="text_no_employees_found" />
            </Cell>
        </Row>
    );
}
